const warningCodes = [
  'CannotUntrackForXMinutesError',
]

export { warningCodes }
